function onlyNumberKey(evt) {
  const ASCIICode = evt.which ? evt.which : evt.keyCode;
  const allowedChars = /[0-9()+\s-]/; // Define a regular expression for allowed characters

  // Allow keypress if the character is allowed or if it's a special key (e.g., backspace, delete)
  if (
    allowedChars.test(String.fromCharCode(ASCIICode)) ||
    ASCIICode == 8 ||
    ASCIICode == 46
  ) {
    return true;
  } else {
    return false;
  }
}

function validateInput(input) {
  const trimmedValue = input.value.trim();
  if (trimmedValue === "") {
    input.setCustomValidity("Please enter a valid input");
  } else {
    input.setCustomValidity("");
  }
}

let autocompleteStreet1;
let autocompleteStreetBilling;

// This function is called when the Google Maps API is loaded
function initAutocomplete() {
  initStreet1Autocomplete();
  initStreetBillingAutocomplete();
}

// Initialize autocomplete for the street_1 input
function initStreet1Autocomplete() {
  let input = document.getElementById("street_1");
  if (input) {
    input.addEventListener("focus", () => geolocate(autocompleteStreet1), true);
    autocompleteStreet1 = new google.maps.places.Autocomplete(input, {
      types: ["geocode"],
    });
    autocompleteStreet1.addListener("place_changed", fillInAddress);
  } else {
    console.error("Element with ID 'street_1' not found.");
  }
}

// Initialize autocomplete for the street_billing input
function initStreetBillingAutocomplete() {
  let billingInput = document.getElementById("street_billing");
  if (billingInput) {
    billingInput.addEventListener(
      "focus",
      () => geolocate(autocompleteStreetBilling),
      true
    );
    autocompleteStreetBilling = new google.maps.places.Autocomplete(
      billingInput,
      { types: ["geocode"] }
    );
    autocompleteStreetBilling.addListener(
      "place_changed",
      fillInBillingAddress
    );
  } else {
    console.error("Element with ID 'street_billing' not found.");
  }
}

// This function is called when the input field is focused
function geolocate(autocomplete) {
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(function (position) {
      var geolocation = {
        lat: position.coords.latitude,
        lng: position.coords.longitude,
      };

      var circle = new google.maps.Circle({
        center: geolocation,
        radius: position.coords.accuracy,
      });

      autocomplete.setBounds(circle.getBounds());
    });
  }
}

// Function to fill in address details for street_1 input
function fillInAddress() {
  let place = autocompleteStreet1.getPlace();
  let streetAddress = "";

  if (!place || !place.address_components) {
    console.error("Invalid place object or address_components missing");
    return;
  }

  for (let i = 0; i < place.address_components.length; i++) {
    let component = place.address_components[i];

    if (component.types.includes("street_number")) {
      streetAddress += component.long_name + " ";
    }

    if (component.types.includes("route")) {
      streetAddress += component.long_name;
    }
    document.getElementById("street_1").value = streetAddress.trim();

    if (component.types.includes("locality")) {
      document.getElementById("customer_notes_City").value =
        component.long_name;
    }

    if (component.types.includes("administrative_area_level_1")) {
      document.getElementById("customer_notes_Province").value =
        component.long_name;
      document.getElementById("customer_notes_ProvinceCode").value =
        component.short_name;
    }

    if (component.types.includes("postal_code")) {
      document.getElementById("customer_notes_Zip").value = component.long_name;
    }

    if (component.types.includes("country")) {
      let countrySelect = document.getElementById("customer_country");
      const countryIDSelect = document.getElementById("customer_notes_country");
      for (let j = 0; j < countrySelect.options.length; j++) {
        if (countrySelect.options[j].text === component.long_name) {
          countrySelect.selectedIndex = j;
          countryIDSelect.value = component.short_name;
          break;
        }
      }
    }
  }
}

// Function to fill in address details for street_billing input
function fillInBillingAddress() {
  let place = autocompleteStreetBilling.getPlace();
  let streetAddress = "";

  if (!place || !place.address_components) {
    console.error("Invalid place object or address_components missing");
    return;
  }

  for (let i = 0; i < place.address_components.length; i++) {
    let component = place.address_components[i];

    if (component.types.includes("street_number")) {
      streetAddress += component.long_name + " ";
    }

    if (component.types.includes("route")) {
      streetAddress += component.long_name;
    }
    document.getElementById("street_billing").value = streetAddress.trim();

    if (component.types.includes("locality")) {
      document.getElementById("customer_notes_City_billing").value =
        component.long_name;
    }

    if (component.types.includes("administrative_area_level_1")) {
      document.getElementById("customer_notes_Province_billing").value =
        component.long_name;
      document.getElementById("customer_notes_ProvinceCode_billing").value =
        component.short_name;
    }

    if (component.types.includes("postal_code")) {
      document.getElementById("customer_notes_Zip_billing").value =
        component.long_name;
    }

    if (component.types.includes("country")) {
      let countrySelect = document.getElementById("customer_country_billing");
      const countryIDSelect = document.getElementById(
        "customer_notes_country_billing"
      );
      for (let j = 0; j < countrySelect.options.length; j++) {
        if (countrySelect.options[j].text === component.long_name) {
          countrySelect.selectedIndex = j;
          countryIDSelect.value = component.short_name;
          break;
        }
      }
    }
  }
}

$(document).ready(function () {
  // Bind event listener to form submission
  $("#registration-form").submit(function (event) {
    // Prevent default form submission
    event.preventDefault();
    let loginUrl = "https://account.restaurantware.com";
    let redirectUrl = "/pages/account-creation-failed";
    // loader show
    let spinnerElement = document.querySelector(".customer_login_spinner");
    let buttonID = document.querySelector(".company_custom_button");
    spinnerElement.style.display = "block";
    buttonID.setAttribute("disabled", "true");

    // Serialize form data
    var formData = $(this).serialize();
    // Send AJAX request
    $.ajax({
      type: "POST",
      // url: 'https://all-shopify-customer-signup-forms.onrender.com',
      url: "https://rw-shopify-signupforms-app-qhz3.onrender.com",
      data: formData,
      success: function (response) {
        window.location.href = loginUrl;
        // loader icon hide
        // spinnerElement.style.display = "none"
        // buttonID.setAttribute('disabled', 'false');
      },
      error: function (error) {
        // Handle errors
        console.error("Error Status", error.status);
        window.location.href = redirectUrl + `?statusCode=${error.status}`;
        // loader icon hide
        // spinnerElement.style.display = "none"
        // buttonID.setAttribute('disabled', 'false');
      },
      beforeSend: function () {
      },
    });
  });
});
